import React from 'react';
import useAwards from 'hooks/queries/useAwards';
import useContactSettings from 'hooks/queries/useContactSettings';
import styled from 'styled-components';
import Typography from 'components/Typography';
import Spacer from 'components/Spacer';
import AwardQuery_Award from 'src/transformers/AwardQuery_Award';
import isNotNull from 'src/types/guards/isNotNull';
import TelephoneNumber from 'src/helpers/TelephoneNumber';

interface Props {
  title: string,
  subTitle: string,
}

const InfoSection:React.FC<Props> = ({ title, subTitle }) => {
  const awardsRaw = useAwards();
  const awards = Array.from(awardsRaw, AwardQuery_Award).filter(isNotNull);
  const { telephoneNumber: telephoneNumberRaw } = useContactSettings();
  const telephoneNumber = new TelephoneNumber(telephoneNumberRaw || '');
  return (
    <InfoSectionOuter>
      <Typography variant="h1">{title}</Typography>
      <Spacer mb={3} />
      <Typography variant="h5" as="h2">{subTitle}</Typography>
      <Spacer mb={3} />
      {telephoneNumber && (
        <TelephoneNumberLink
          href={`tel:${telephoneNumber.cleanDigits}`}
        >
          {telephoneNumber.internationalFormatted}
        </TelephoneNumberLink>
      )}
      <AwardsWrap>
        {awards.map((award) => (
          <Award key={award._id}>
            <AwardTitle>{award.name}</AwardTitle>
            <AwardPlacementType>{award.placementType}</AwardPlacementType>
            <AwardYear>{award.year}</AwardYear>
          </Award>
        ))}
      </AwardsWrap>
    </InfoSectionOuter>
  );
};
export default InfoSection;

const InfoSectionOuter = styled.section`
  color: ${(p) => p.theme.palette.primary};
`;

const AwardsWrap = styled.div``;
const Award = styled.p`
  display: flex;
`;
const AwardText = styled.span`
  margin: 0.1em;  
`;
const AwardTitle = styled(AwardText)``;
const AwardPlacementType = styled(AwardText)``;
const AwardYear = styled(AwardText)``;
const TelephoneNumberLink = styled.a``;
